export default "/8522fe2631ecefb1e3967be9883671f05392a386/b3dc542ec1b5794376b3d1da54a4e35b.svg";